import React from "react";
import { Mail } from "lucide-react";

export function Footer() {
  return (
    <footer
      className="border-t border-[#E5E7EB] bg-[#F9FAFB] px-6 py-3 text-xs text-[#6B7280] flex flex-col md:flex-row items-start md:items-center justify-between gap-1 md:gap-4"
      data-testid="app-footer"
    >
      <div className="flex items-center gap-1.5" data-testid="footer-contact">
        <Mail className="h-3 w-3" />
        <span className="font-semibold uppercase tracking-wider text-[#4B5563]">Contact Us!</span>
        <a
          href="mailto:aiqtechofficial@gmail.com"
          className="text-[#0F172A] font-medium hover:underline"
          data-testid="footer-contact-email"
        >
          aiqtechofficial@gmail.com
        </a>
      </div>
      <div className="text-[#6B7280]" data-testid="footer-thanks">
        Thanks for using <span className="font-semibold"><span className="text-[#0F172A]">Swift</span><span className="text-[#0080FF]"> Register</span></span> app.
      </div>
    </footer>
  );
}

export default Footer;
